import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { SharedService } from '../dashboard/shared.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {

  public user:any;
  public project:any;

  constructor(
    private authService: AuthService,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.user = this.sharedService.getUser();
    this.project = this.sharedService.getProject();
  }

  logout(){
    this.authService.logout();
  }

}
